import React, { useMemo } from "react";
import { Flame } from "lucide-react";
import { useFinance } from "@/context/FinanceContext";
import { loggingStreak } from "@/lib/insights";

export function StreakCard({ className = "" }) {
  const { finance } = useFinance();
  const s = useMemo(() => loggingStreak(finance), [finance]);

  if (!finance) return null;

  const active = s.current > 0;
  return (
    <div
      className={`flex items-center gap-3 rounded-3xl border p-4 shield-shadow ${active ? "border-orange-100 bg-orange-50" : "border-zinc-200 bg-white"} ${className}`}
      data-testid="streak-card"
    >
      <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${active ? "bg-orange-500 text-white" : "bg-zinc-100 text-zinc-400"}`}>
        <Flame className="h-6 w-6" />
      </div>
      <div className="min-w-0 flex-1">
        {active ? (
          <>
            <p className="font-heading text-sm font-bold text-zinc-900" data-testid="streak-current">
              {s.current} hari berturut-turut mencatat 🔥
            </p>
            <p className="mt-0.5 text-xs text-zinc-500">
              {s.loggedToday ? "Mantap, hari ini sudah tercatat!" : "Catat hari ini agar rentetan tetap jalan."}
              {s.longest > s.current ? ` Rekor terpanjang: ${s.longest} hari.` : ""}
            </p>
          </>
        ) : (
          <>
            <p className="font-heading text-sm font-bold text-zinc-900">Mulai rentetan mencatat</p>
            <p className="mt-0.5 text-xs text-zinc-500">
              Catat transaksi hari ini untuk memulai lagi.{s.longest > 0 ? ` Rekor terpanjang Anda: ${s.longest} hari.` : ""}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
